﻿import axios from 'config/axios';

export default class ProductService {
  static async getOrderMoreProducts() {
    const { data } = await axios.get('products/order-more-products/');
    return data;
  }
}
